import React, { Component } from 'react'
import { connect } from 'react-redux'
import Ink from 'react-ink';
import { setSplitReceiptModal } from '../../actions/modalActions'
import * as resource from '../../../constants/Resources'
import { getTranslation } from '../../../actions/dataActions'
import PropTypes from 'prop-types'

class SplitReceiptModalRightReceipt extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    handleTouchTap(lineid, quantity) {
        if(quantity!==0)
            this.props.callback(lineid);
    }

    closeModal() {
        this.props.setSplitReceiptModal(false, [], [], null);
    }

    componentDidMount() {
        // const list = document.querySelector('#right_receipt_ul');
        // new Slip(list);
        // list.addEventListener('slip:swipe', this.onSwipe.bind(this));
        // list.addEventListener('slip:beforereorder', function (e) {
        //     e.preventDefault();
        // });      
    }

    onSwipe() {
        const lineid = parseInt(arguments[0].target.id, 10);
        this.props.callback(lineid);
    }

    render() {
        let totalprice = 0;
        return (
            <div className="receiptRight_wrapper">
                <div className="header">
                    Bon
                </div>
                <div className="receipt">
                    <div className="scrollable  no_user_select" id="right_receipt_ul">
                        {
                            this.props.receiptlines.map(line => {
                                totalprice += line.price;
                                return (
                                    <div className="receiptLine no_user_select" key={line.id} id={line.id} onClick={() => this.handleTouchTap(line.id, line.quantity)}>
                                        <div className="amount">
                                            {line.quantity}x
                                            </div>
                                        <div className="description">
                                            {line.text}
                                        </div>
                                        <div className="price">
                                            {line.price.toFixed(2).replace('.', ',')}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="receiptFooter">
                    <div className="footer_top">
                        <div className="text_total">
                            {this.props.getTranslation(resource.SUB_TOTAL)}
                        </div>
                        <div className="totalprice_wrapper">
                            <div className="top">
                                {totalprice.toFixed(2).replace('.', ',')}
                        </div>                 
                    </div>

                    </div>
                    <div className="footer_bottom">
                        <button className="btnCancel" onClick={this.closeModal} >{this.props.getTranslation(resource.CANCEL)}</button>
                        <button className="btnPayment" onClick={this.props.confirm}>
                            {this.props.confirmbuttontext}
                            <Ink />
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}
SplitReceiptModalRightReceipt.propTypes = {
    receiptModal: PropTypes.object.isRequired,
    callback: PropTypes.func,
    inputquantity: PropTypes.string,
    inputquantitynegative: PropTypes.bool,
    receiptnumber: PropTypes.number
}

function mapStateToProps(state) {
    return {
        receiptModal: state.modalState.splitReceiptModal,
        inputquantity: state.receiptState.input.inputquantity,
        inputquantitynegative: state.receiptState.input.inputquantitynegative
    }
}

export default connect(mapStateToProps, { setSplitReceiptModal, getTranslation })(SplitReceiptModalRightReceipt)


// WEBPACK FOOTER //
// src/modal/components/SplitReceiptModal/SplitReceiptModalRightReceipt.jsx